import { createValidator } from "utils/forms.utils";

export const validator = createValidator({
  reason: {
    presence: { allowEmpty: false },
  },
});
